module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-percent-section"
  }, _vm._l((_vm.props), function(item) {
    return _c('div', {
      staticClass: "custom-percent-section__columnes"
    }, [_c('div', {
      staticClass: "custom-percent-section__percent"
    }, [_c('VueTrigger', {
      attrs: {
        "function1": _vm.googleIt,
        "function2": _vm.percentTrigger
      }
    }), (_vm.$store.state.body === 1) ? _c('animate-number', {
      attrs: {
        "from": 0,
        "to": item.number,
        "duration": "2000",
        "fromColor": "#fff",
        "toColor": "#ff6b00"
      }
    }) : _vm._e()], 1), _c('div', {
      staticClass: "custom-percent-section__sign"
    }, [_vm._v("%")]), _c('div', {
      staticClass: "custom-percent-section__body"
    }, [_vm._v(_vm._s(item.text)), _c('a', {
      staticClass: "custom-percent-section__body--button",
      attrs: {
        "href": item.button.href
      }
    }, [_vm._v(_vm._s(item.button.label))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b7275e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-percent-section/custom-percent-section.pug
// module id = 596
// module chunks = 1